import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openWorkflowsSubmenu } from '../sidebarHelpers';

const workflowsPreview = (baseUrl, navigate, cartAbandonmentWorkflow, user) => {
  return {
    id: 'workflowsPreview',
    title: 'Workflows preview',
    steps: [
      {
        selector: '[data-tour="workFlowsLink"]',
        content: (
          <p>
            Workflows are scenarios where automation sends certain communication to each customer depending on their
            actions.
          </p>
        ),
      },
      {
        actionBefore: () => openWorkflowsSubmenu('[data-tour="workflowsContinuousLink"]'),
        selector: '[data-tour="workflowsContinuousLink"]',
        content: (
          <p>
            Some common scenarios are already included here: Abandoned cart, abandoned browsing, and personalized weekly
            promo.
          </p>
        ),
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/workflows/${cartAbandonmentWorkflow.id}/details?mode=continuous`, true);
        },
        selector: '[data-tour="workflowDetails"]',
        content: (
          <>
            <p>
              Each workflow can include multiple steps, conditions, and communication channels depending on your
              marketing strategy.
            </p>
            <p>You can also have multiple conditions splits.</p>
          </>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/workflows?mode=oneOff`, true),
        selector: '[data-tour="newElementBtn"]',
        content: <p>Create a Workflow.</p>,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/workflows/new?mode=oneOff`, true),
        selector: '[data-tour="workFlowContent"]',
        content: (
          <p>
            Each Workflow starts with a <strong>"Start"</strong> which is already set up for you.
          </p>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/workflows/new?mode=oneOff`, true),
        selector: '[data-tour="addVisualElement"]',
        content: (
          <p>You can choose from multiple options for conditions and add filters to further specify the conditions.</p>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/workflows/new?mode=oneOff`, true),
        selector: '[data-tour="flow"]',
        content: (
          <p>
            <strong>Add</strong> a condition according to which the workflow will be executed.
          </p>
        ),
        stepInteraction: true,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/workflows/new?mode=oneOff`, true),
        selector: '[data-tour="flow"]',
        content: (
          <>
            <p>
              <strong>Add</strong> a Wait element.
            </p>
            <p>The element allows you to put a delay between each step in the flow.</p>
          </>
        ),
        stepInteraction: true,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/workflows/new?mode=oneOff`, true),
        selector: '[data-tour="flow"]',
        content: (
          <p>
            <strong>Connect</strong> the dots of all the elements to create a continuous flow.
          </p>
        ),
        stepInteraction: true,
      },
      {
        actionBefore: () => {
          navigate(`${baseUrl}/workflows/new?mode=oneOff`, true);
        },
        selector: '[data-tour="nextButtonWorkflows"]',
        content: <p>Click on the "Save" button.</p>,
      },
      {
        actionBefore: () => {
          document.querySelector('[data-tour="camapaignAudienceTab"]')?.click();
          navigate(`${baseUrl}/workflows/new?mode=oneOff&tab=audience`, true);
        },
        selector: '[data-tour="audienceScope"]',
        content: (
          <>
            <p>All workflows should be sent as Marketing emails.</p>
            <p>
              Transactional messages are meant to explain terms of service changes, new delivery options, etc. where
              there is no marketing content at all.
            </p>
          </>
        ),
        stepInteraction: true,
      },
      {
        actionBefore: () => {
          document.querySelector('[data-tour="camapaignAudienceTab"]')?.click();
          navigate(`${baseUrl}/workflows/new?mode=oneOff&tab=audience`, true);
        },
        selector: '[data-tour="audienceSegment"]',
        content: (
          <>
            <p>In this section, you can select what group of users you will address with your workflow.</p>
            <p>
              You can select from a number of predefined segments or you can create your own in the Segment section.
            </p>
            <p>When you're sending your weekly newsletter you should select the segment called "Everyone".</p>
          </>
        ),
        stepInteraction: true,
      },
      {
        actionBefore: () => {
          document.querySelector('[data-tour="camapaignAudienceTab"]')?.click();
          navigate(`${baseUrl}/workflows/new?mode=oneOff&tab=audience`, true);
        },
        selector: '[data-tour="nextButtonWorkflows"]',
        content: <p>Click on the "Next" button.</p>,
      },
      {
        action: () => document.querySelector('#On')?.click(),
        actionBefore: () => {
          document.querySelector('[data-tour="camapaignLaunchConfigurationTab"]')?.click();
          navigate(`${baseUrl}/workflows/new?mode=oneOff&tab=launchConfiguration`, true);
        },
        selector: '[data-tour="delayedStart"]',
        content: (
          <>
            <p>If you want to prepare your email and send it later you can use the delayed start functionality.</p>
            <p>Click the ON button and select the date and time for your campaign to start.</p>
          </>
        ),
        stepInteraction: true,
      },
      {
        selector: '[data-tour="campaignGoalSettings"]',
        content: (
          <p>
            Here you can configure what the goal of the campaign is. You will then be able to see the number of times
            the campaign achieved its goal, alongside the associated monetary value.
          </p>
        ),
        stepInteraction: true,
        actionBefore: () => document.querySelector('[data-tour="camapaignGoalTab"]')?.click(),
      },
      {
        selector: '[data-tour="workflowsSaveBtn"]',
        content: <p>Click on the "Save" button".</p>,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/workflows?mode=oneOff`, true),
        selector: '[data-tour="workflowsStatus"]',
        content: (
          <>
            <p>
              After you are done making changes to your campaign you can click the "Launch" button to start it. The
              status will change to Running.
            </p>
            <p>If you want to send the campaign with a delayed start the "Launch" button starts the countdown.</p>
            <p>In this case, the status of your campaign will be "Scheduled".</p>
          </>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find((a) => a.action === 'taskCompleted' && a.context.task === 'workflowsPreview'),
  };
};

export default workflowsPreview;
